import React, { Component } from 'react';
import './MenuBar.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';

class MenuBar  extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
        };
    }


    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    

    render() {
        return (
            <div className='canvas-menu-component'>
                <div onClick={ () => this.props.createArrow('arrowRight')} className="icon-box">
                    <i className="fas fa-long-arrow-alt-right"></i>
                </div>
                <div onClick={ () => this.props.createArrow('arrowAtBeginning')} className="icon-box">
                    <i className="fas fa-arrows-alt-h"></i>
                </div>
                <div  onClick={ () => this.props.createArrow('arrowRightDash')} className="icon-box">
                    <i className=" fas fa-angle-double-right"></i>
                </div>
                <div onClick={ () => this.props.createArrow('arrowAtBeginningDash')} className="icon-box duble-icon-box">
                    <i className="fas fa-angle-double-left"></i>
                    <i className=" fas fa-angle-double-right"></i>
                </div>
                <div  onClick={ () => this.props.deleteElement('delete')} className="icon-box">
                    <i className="fa fa-trash" aria-hidden="true"></i>
                </div>
                <div  onClick={this.props.addArrowHeight}  className="icon-box half">
                    <i className="fas fa-plus"></i>
                </div>
                <div onClick={this.props.minusArrowHeight} className="icon-box half">
                    <i className="fas fa-window-minimize"></i>
                </div>
                <div onClick={ () => this.props.onChangeColor('#fff')} className="icon-box three-part white"></div>
                <div onClick={ () => this.props.onChangeColor('#ccc')} className="icon-box three-part gray"></div>
                <div  onClick={ () => this.props.onChangeColor('#83c6ae')}className="icon-box three-part green"></div>
                <div onClick={ () => this.props.onChangeColor('#cdaa82')} className="icon-box three-part brown"></div>
                <div onClick={ () => this.props.onChangeColor('#c7cc7c')} className="icon-box three-part dark-yellow"></div>
                <div onClick={ () => this.props.onChangeColor('#76d068')} className="icon-box three-part dark-green"></div>
                <div onClick={ () => this.props.onChangeColor('#cba5d6')} className="icon-box three-part purple"></div>
                <div onClick={ () => this.props.onChangeColor('#93a2d1')} className="icon-box three-part dark-purple"></div>
                <div onClick={ () => this.props.onChangeColor('#e49f8f')} className="icon-box three-part orange"></div>
                    
            </div> 
        )
    }
}

export default (MenuBar);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerInfluencerMap/MenuBar/MenuBar.jsx